import { Component, OnInit, ViewChild,  } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { ProcessEditComponent } from '../process-edit/process-edit.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'process-edit-modal',
    templateUrl: './process-edit-modal.component.html',
    standalone: true,
    imports: [
      AfTranslateDirective, 
      ProcessEditComponent,
      AfTranslatePipe]
})
export class ProcessEditModalComponent implements OnInit {
  constructor(private globalCfg:GlobalCfgFactory,
    private dialogRef: DynamicDialogRef<ProcessEditModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  skin: string = this.globalCfg.skin;
  evaluationId: any = this.dialogConfig.data.evaluationId;
  concept: any = this.dialogConfig.data.concept;
  processEditModal: any = {
    showInfo: true,
    modal: null,
    isNew: false,
    showHeaderInfo: false
  };

  @ViewChild(ProcessEditComponent)
  processEdit: ProcessEditComponent;



  ngOnInit(): void {
    console.log(this.concept);
    this.processEditModal.isNew = Boolean(this.concept.processId)
    this.processEditModal.showHeaderInfo = Boolean(this.concept.allEvaluated.length > 0)
  }

  processUpdated(e:any) {
    let data: any = e.data;
    this.dialogRef.close({
      result: 'ok',
      data: data
    })
  }

  deleteProcess(){
    this.processEdit.deleteProcess();
  }
  saveProcess(){
    this.processEdit.saveProcess(true)
  }
  cancel(){
    if(this.concept.processId && this.processEdit.processEdit.modified){
      this.processEdit.cancel('restore');
    }else{
      this.handleDismiss()
    }
  }

  handleDismiss() {
    this.dialogRef.close({result: 'cancel'});
  }
}
